import styled from 'styled-components';
import { errorColor } from '~theme';

const Error = styled.div`
  color: ${errorColor};
  font-size: 16px;
  margin: 4px;
`;

export default Error;
